import type { ReactNode } from "react";
import { useMemo } from "react";
import { AuthContext } from "@features/auth/AuthContext";
import { useMe } from "@features/auth/queries";
import type { Role } from "@/types/session";

export function AuthProvider({ children }: { children: ReactNode }) {
  const { data, isLoading } = useMe();
  const user = data ?? null;

  const value = useMemo(
    () => ({
      user,
      loading: isLoading,
      hasRole: (...roles: Role[]) => Boolean(user && roles.includes(user.role)),
    }),
    [user, isLoading]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
